import { IExcelRowDecorator } from "./iexcel-row-decorator";
import * as Excel from "exceljs";

export class ExcelIncorrectOperationProductDataDecorator implements IExcelRowDecorator {
    private readonly _validateRowFn: (row: Excel.Row) => number[];

    public constructor(validateRowFn: (row: Excel.Row) => number[]) {
        this._validateRowFn = validateRowFn;
    }

    public decorate(row: Excel.Row) {
        if (row.worksheet.id !== 0) {
            return;
        }

        this._validateRowFn(row).forEach(columnPosition => {
            row.getCell(columnPosition + 1).fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: {
                    argb: "FFFFB74D",
                },
            };
        });
    }

    public reset() {
        return;
    }
}
